import styled from 'styled-components';

export const Wrapper = styled.div`
	max-width: 1245px;
	width: 100%;
	padding: 0 20px;
	margin: 0 auto;
	position: relative;
	z-index: 10;

	.mo-banner-wrap {
		display: none;
	}
	.flex-wrapper {
		display: flex;
		.left {
			max-width: 880px;
			width: 100%;
			border-right: 1px solid #eee;
			padding-right: 80px;
			.result {
				display: flex;
				justify-content: center;
				height: 624px;
				position: relative;
				.result-box {
					width: 279px;
					height: 168px;
					background-image: url(/images/result.png);
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					p {
						padding-top: 44px;
						text-align: center;
						font-size: 18px;
						font-weight: 400;
						line-height: 150%;
					}
				}
			}
			.input-box {
				margin-top: 98px;
				position: relative;
				img {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 17px;
					cursor: pointer;
				}
				input {
					width: 100%;
					border-radius: 10px;
					background: #f7f7f7;
					border: none;
					padding: 13px 17px 12px 46px;
					font-size: 14px;
					font-weight: 400;
					line-height: 150%;
				}
			}
			.total-box {
				margin-top: 54px;
				p {
					font-size: 18px;
					font-weight: 400;
					line-height: 150%;
					span {
						color: #ffbc00;
					}
				}
			}
			.press-wrap {
				margin-top: 54px;
				h1 {
					font-size: 30px;
					font-weight: 700;
					line-height: 140%;
				}
				.press-list {
					display: flex;
					gap: 20px;
					flex-wrap: wrap;
					margin-top: 38px;
					.box {
						border-radius: 14px;
						border: 1px solid #eee;
						background: #fff;
						padding: 17px 28px 17px 24px;
						width: calc((100% - 20px) / 2);
						cursor: pointer;
						transition: all 0.3s;
						&:hover {
							opacity: 0.8;
						}
						.flex {
							display: flex;
							align-items: center;
							justify-content: space-between;
							.press-left {
								display: flex;
								align-items: center;
								gap: 16px;
								.press {
									width: 48px;
									height: 48px;
									background-repeat: no-repeat;
									background-size: cover;
									background-position: center;
									border: 1px solid #eee;
									border-radius: 50%;
								}
								.name {
									display: flex;
									align-items: center;
									gap: 4px;
									font-size: 14px;
									font-weight: 700;
									line-height: 160%;
									img {
										position: relative;
										top: -1px;
									}
								}
								span {
									font-size: 12px;
									font-weight: 400;
									line-height: 160%;
									opacity: 0.6;
									margin-top: 4px;
									display: inline-block;
								}
							}
							.press-right {
								.writing-article {
									display: flex;
									gap: 14px;
									border-radius: 70px;
									background: rgba(0, 0, 0, 0.06);
									padding: 4px 14px;
									color: #666;
									font-size: 12px;
									line-height: 160%;
									p {
										font-weight: 400;
										position: relative;
										&:after {
											position: absolute;
											content: '';
											width: 2px;
											height: 2px;
											border-radius: 50%;
											background-color: #666;
											right: -7px;
											top: 50%;
											transform: translateY(-50%);
										}
									}
									span {
										font-weight: 500;
									}
								}
							}
						}
					}
				}
			}
			.bold-line {
				border-top: 8px solid #f7f7f7;
				margin: 80px 0 60px 0;
			}
		}
		.right {
			margin-top: 0;
			padding-left: 40px;
			max-width: 340px;
			width: 100%;

			.series {
				margin-top: 100px;
				h3 {
					font-size: 18px;
					font-weight: 700;
					margin-bottom: 26px;
				}
				.series-list {
					.list {
						margin-top: 20px;
						transition: all 0.3s;
						a {
							display: inline-flex;
							align-items: center;
							gap: 24px;
						}
						&:hover {
							opacity: 0.8;
						}
						.seriesimg {
							width: 68px;
							height: 68px;
							background-repeat: no-repeat;
							background-size: cover;
							background-position: center;
						}
						.text-box {
							h4 {
								font-size: 16px;
								font-weight: 700;
							}
							p {
								margin-top: 6px;
								color: #666;
								font-size: 14px;
								font-weight: 400;
							}
						}
					}
				}
			}
			.tag {
				margin-top: 100px;
				h3 {
					font-size: 18px;
					font-weight: 700;
				}
				ul {
					margin-top: 26px;
					display: flex;
					flex-wrap: wrap;
					gap: 12px 10px;
					li {
						padding: 7px 18px;
						border-radius: 50px;
						border: 1px solid #eee;
						background: #fff;
						font-size: 16px;
						font-weight: 300;
						display: inline-block;
						cursor: pointer;
						transition: all 0.3s;
						&:hover {
							background: #f7f7f7;
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 1100px) {
		.flex-wrapper {
			display: flex;
			.left {
				padding-right: 30px;
				.article-wrap {
					margin-left: 2px;
					.article-card {
						gap: 20px;
						.article-img {
							width: 180px;
							padding-bottom: 70%;
						}
						.text-box {
							h3 {
								margin-top: 7px;
								font-size: 18px;
							}
							.flex {
								p {
									font-size: 12px;
								}
								.name {
									font-size: 12px;
								}
								.date {
									font-size: 12px;
								}
							}
						}
					}
				}
			}
			.right {
				padding-left: 30px;
				max-width: 280px;
			}
		}
	}
	@media screen and (max-width: 768px) {
		margin-top: 30px;
		.flex-wrapper {
			flex-wrap: wrap;
			.left {
				max-width: 100%;
				border-right: none;
				padding-right: 0;
				.result {
					height: 400px;
					.result-box {
						width: 220px;
						height: 132px;
						p {
							padding-top: 35px;
							font-size: 14px;
						}
					}
				}
				.input-box {
					margin-top: 0;
					img {
						left: 16px;
					}
					input {
						padding: 14px 16px 14px 46px;
					}
				}
				.total-box {
					margin-top: 36px;
					p {
						font-size: 15px;
					}
				}
				.press-wrap {
					margin-top: 38px;
					margin-bottom: 60px;
					h1 {
						font-size: 22px;
					}
					.press-list {
						gap: 14px;
						margin-top: 20px;
						.box {
							padding: 17px 20px;
							width: 100%;
							.flex {
								.press-right {
									.writing-article {
										display: flex;
										gap: 14px;
										border-radius: 70px;
										background: rgba(0, 0, 0, 0.06);
										padding: 4px 14px;
										color: #666;
										font-size: 12px;
										line-height: 160%;
										p {
											font-weight: 400;
											position: relative;
											&:after {
												position: absolute;
												content: '';
												width: 2px;
												height: 2px;
												border-radius: 50%;
												background-color: #666;
												right: -7px;
												top: 50%;
												transform: translateY(-50%);
											}
										}
										span {
											font-weight: 500;
										}
									}
								}
							}
						}
					}
				}
				.bold-line {
					margin: 60px -20px;
				}
			}
			.mo-banner-wrap {
				width: 100%;
				display: block;
				.mo-banner {
					padding: 22px 24px;
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;
					border-radius: 8px;
					p {
						font-size: 18px;
						font-weight: 600;
						line-height: 140%;
						max-width: 185px;
						word-break: keep-all;
						margin-bottom: 12px;
					}
					span {
						display: flex;
						align-items: center;
						gap: 6px;
						font-size: 12px;
						font-weight: 400;
						line-height: normal;
						img {
							width: 4px;
							height: 8px;
						}
					}
				}
				.line {
					border-bottom: 8px solid #f7f7f7;
					margin: 60px -20px 0 -20px;
				}
			}
			.right {
				padding-left: 0;
				max-width: 100%;

				.series {
					margin-top: 60px;
					h3 {
						margin-bottom: 20px;
					}
					.series-list {
						.list {
							gap: 20px;
							margin-top: 20px;
							.seriesimg {
								width: 58px;
								height: 58px;
							}
						}
					}
				}
				.tag {
					margin-top: 60px;
					ul {
						margin-top: 20px;
					}
				}
			}
		}
	}
`;

export const BannerWrapper = styled.div`
	margin-top: 100px;
	.banner {
		width: 100%;
		background: #d9d9d9;
		padding: 60px 60px 54px 60px;
		border-radius: 18px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
		p {
			font-size: 30px;
			font-weight: 600;
			margin-bottom: 23px;
		}
		span {
			font-size: 18px;
			font-weight: 400;
			display: flex;
			align-items: center;
			gap: 10px;
			cursor: pointer;
			transition: all 0.3s;
			&:hover {
				opacity: 0.8;
			}
		}
	}
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
